// extracted by mini-css-extract-plugin
export var askAiIcon = "_or-k";
export var category = "_or-a";
export var categoryHeader = "_or-f";
export var container = "_or-0";
export var group = "_or-b";
export var groupItems = "_or-g";
export var groupSeparator = "_or-l";
export var highlight = "_or-8";
export var loading = "_or-1";
export var noResults = "_or-3";
export var placeholder = "_or-2";
export var resultContent = "_or-5";
export var resultIcon = "_or-d";
export var resultItem = "_or-h";
export var resultMeta = "_or-9";
export var resultSubtitle = "_or-7";
export var resultSuffix = "_or-j";
export var resultTitle = "_or-6";
export var resultsList = "_or-4";
export var searchGroup = "_or-e";
export var selected = "_or-i";
export var subgroup = "_or-c";